module.exports = __webpack_public_path__ + "media/images/vp/icon.menu.gift.gray-d29f94371644d53b50aafee90575a824.svg";